import { createAsyncThunk } from '@reduxjs/toolkit';
import { deleteMfaOverrideRequest } from 'api/requests/user-mfa-requests';
import { USER_MFA__DELETE_OVERRIDE } from 'store/constants';
import logError from 'utils/log-error';

/**
 * Moves a user back to "no override". Only dispatched for a SuperAdmin that is not impersonating,
 * and only when the user actually had an override stored - a user without one has nothing to clear,
 * and every rejected call is recorded server-side as a security event.
 */
export const deleteMfaOverrideAction = createAsyncThunk(
  USER_MFA__DELETE_OVERRIDE,
  async (props: { userId: number }): Promise<boolean> => {
    try {
      return await deleteMfaOverrideRequest(props.userId);
    } catch (error) {
      logError(error);
      return false;
    }
  },
);

export default deleteMfaOverrideAction;
